import React from 'react';

import Defaults from '../../../shared/constants/defaults';
import FormSettings from '../../../shared/constants/form-settings';

import SVGIcon from '../../../../../../common/react/components/svg-icon';

import classNames from 'classnames';

export default class LimitSubmissions extends React.Component {
	render() {
		let { localization } = this.props;

		let limitSubmissions = this.props.limitSubmissions ? true : false;

		let openGroupClasses = classNames({
			'display' : limitSubmissions
		}, 'inputs');

		return (
			<section className='limit-submissions'>
				<input
					id='limit_submissions'
					type='checkbox'
					checked={limitSubmissions}
					onChange={this.handleToggle(FormSettings.LIMIT_SUBMISSIONS)}
				></input>
				<label htmlFor='limit_submissions'>{localization.substitute('Maximum submissions reached')}</label>
				<div className={openGroupClasses}>
					<div className="icon input">
						<input
							ref='limitSubmissionLabelInput'
							id='limit_submission_input'
							type='number'
							placeholder='None'
							defaultValue={this.props.submissionMax}
							onBlur={this.handleContentChange(FormSettings.SUBMISSION_MAX)}
						></input>
					</div>
				</div>
			</section>
		);
	}
	
	// Custom Methods ------------------------------------------------------------
	handleToggle = (propertyName) => {
		return (evt) => {
			if (evt.target.checked === false) {
				this.props.updateCallback(FormSettings.SUBMISSION_MAX, null)
			}
			this.props.updateCallback(propertyName, evt.target.checked);
		}
	}

	handleContentChange = (propertyName) => {
		return (evt) => {
			if ( this.refs.limitSubmissionLabelInput.value !== '' ) {
				this.props.updateCallback(propertyName, this.refs.limitSubmissionLabelInput.value);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/sections/limitsubmissions.js